import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";
// import 'slim-select/dist/slimselect.css'

// Connects to data-controller="slim-select"
export default class extends Controller {
  static targets = ["field"];
  static values = {
    allowDeselect: { type: Boolean, default: false },
    showSearch: { type: Boolean, default: false },
    placeholderText: { type: String, default: "Select value" },
  }

  connect() {
    const settings = {
      showSearch: this.showSearchValue,
      allowDeselect: this.allowDeselectValue,
      placeholderText: this.placeholderTextValue,
    };
    
    this.slim = new SlimSelect({
      select: this.element,
      settings: settings,
    });

    // Expose a version-stable refresh for peer controllers (e.g. cp2020--skills
    // toggles <option> disabled state for dedup, then needs the widget redrawn).
    // SlimSelect v2 rebuilds from a data array via setData(); we re-derive it from
    // the current <select> options so the caller just mutates the DOM + calls this.
    const select = this.element;
    select.slimSelectRefresh = () => {
      this.slim.setData(
        Array.from(select.options).map((o) => ({
          text: o.textContent,
          value: o.value,
          disabled: o.disabled,
          selected: o.selected,
        }))
      );
    };
  }

  disconnect() {
    // Note: destroy() was causing JS errors when controller disconnects
    // This may be due to SlimSelect API changes or cleanup timing issues
    // Leaving commented out for now - no apparent memory leaks observed
    // this.element.destroy();
  }

}
